/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "telegram-3133b1a6--sprite",
  "use": "telegram-3133b1a6--sprite-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"telegram-3133b1a6--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.707 19.838a.95.95 0 00.886.116.928.928 0 00.579-.672c.695-3.267 2.381-11.537 3.014-14.509a.625.625 0 00-.208-.606.64.64 0 00-.637-.112c-3.355 1.242-13.685 5.118-17.907 6.68a.661.661 0 00-.434.64c.01.282.2.528.475.61 1.893.567 4.379 1.355 4.379 1.355s1.161 3.508 1.767 5.292a.7.7 0 00.482.46c.23.06.477-.003.65-.165l2.476-2.338s2.857 2.095 4.478 3.25zM7.9 12.897l1.344 4.43.298-2.806 8.148-7.348a.222.222 0 00.026-.302.227.227 0 00-.3-.051L7.9 12.897z\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
